<!-- =========================================================================================
File Name: RegisterJWT.vue
Description: Register Page for JWT
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <div v-if="isRegisterJwt" class="min-h-re2">
      <form @submit="registerUserJWt">

        <div class="register-header mb-6">
          <h2 class="register-title">Crea tu cuenta</h2>
          <p class="register-subtitle">
            <span class="badge-free">¡5 firmas gratis!</span>
            Llena los siguientes datos para empezar.
          </p>
        </div>

        <!-- Nombre + Apellidos -->
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2 form-group">
            <label class="form-label">Nombre(s)</label>
            <vs-input
              v-validate="'required|alpha_spaces|min:3'"
              data-vv-as="nombres"
              data-vv-validate-on="blur"
              name="name"
              autocomplete="off"
              placeholder="Tu nombre"
              v-model="name"
              class="w-full input-large" />
            <span class="text-danger">{{ errors.first('name') }}</span>
          </div>

          <div class="vx-col w-full lg:w-1/2 form-group">
            <label class="form-label">Apellidos</label>
            <vs-input
              v-validate="'required|alpha_spaces|min:3'"
              data-vv-as="apellidos"
              data-vv-validate-on="blur"
              name="last_name"
              autocomplete="off"
              placeholder="Tus apellidos"
              v-model="last_name"
              class="w-full input-large" />
            <span class="text-danger">{{ errors.first('last_name') }}</span>
          </div>
        </div>

        <!-- Correo -->
        <div class="form-group mt-4">
          <label class="form-label">Correo electrónico</label>
          <vs-input
            v-validate="'required|email'"
            data-vv-validate-on="blur"
            name="email"
            type="email"
            placeholder="tunombre@empresa.com"
            autocomplete="off"
            v-model="email"
            class="w-full input-large" />
          <span class="text-danger">{{ errors.first('email') }}</span>
        </div>

        <!-- Contraseñas -->
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2 form-group mt-4">
            <label class="form-label">Contraseña</label>
            <div class="password-wrapper">
              <vs-input
                ref="password"
                :type="type"
                data-vv-validate-on="blur"
                v-validate="'required|min:6|max:16'"
                data-vv-as="contraseña"
                name="password"
                placeholder="Mínimo 6 caracteres"
                autocomplete="off"
                v-model="password"
                class="w-full input-large" />
              <button type="button" class="password-toggle" @click="showPassword" :aria-label="type === 'password' ? 'Mostrar' : 'Ocultar'">
                <feather-icon :icon="icon" svgClasses="w-5 h-5" />
              </button>
            </div>
            <span class="text-danger">{{ errors.first('password') }}</span>
          </div>

          <div class="vx-col w-full lg:w-1/2 form-group mt-4">
            <label class="form-label">Confirmar contraseña</label>
            <div class="password-wrapper">
              <vs-input
                :type="type"
                v-validate="'required|min:6|max:16|confirmed:password'"
                data-vv-validate-on="blur"
                data-vv-as="confirmación de contraseña"
                name="confirm_password"
                autocomplete="off"
                placeholder="Repite tu contraseña"
                v-model="password_confirmation"
                class="w-full input-large" />
              <button type="button" class="password-toggle" @click="showPassword" :aria-label="type === 'password' ? 'Mostrar' : 'Ocultar'">
                <feather-icon :icon="icon" svgClasses="w-5 h-5" />
              </button>
            </div>
            <span class="text-danger">{{ errors.first('confirm_password') }}</span>
          </div>
        </div>

        <!-- Honeypot para bots (oculto para humanos) -->
        <div class="honeypot-container" aria-hidden="true">
          <div class="legal-row">
            <input
              type="checkbox"
              v-model="honeypotChecked"
              name="accept_terms_service"
              class="d-none">
            <vs-checkbox v-model="honeypotChecked" name="accept_terms_service"></vs-checkbox>
            <span class="legal-text">
              Acepto los términos del servicio.
            </span>
          </div>
        </div>

        <!-- Términos y privacidad -->
        <div class="legal-block mt-5">
          <div class="legal-row">
            <input
              type="checkbox"
              v-model="isTermsConditionAccepted"
              name="terms"
              v-validate="'required'"
              data-vv-as="términos y condiciones"
              class="d-none">
            <vs-checkbox v-model="isTermsConditionAccepted" name="terms"></vs-checkbox>
            <span class="legal-text">
              Acepto los
              <a target="_blank" href="https://verificamex.com/terminos-y-condiciones">Términos y Condiciones</a>
              del servicio.
            </span>
          </div>
          <span class="text-danger">{{ errors.first('terms') }}</span>

          <div class="legal-row mt-2">
            <input
              type="checkbox"
              v-model="isPrivacyNoticeAccepted"
              name="privacy"
              v-validate="'required'"
              data-vv-as="aviso de privacidad"
              class="d-none">
            <vs-checkbox v-model="isPrivacyNoticeAccepted" name="privacy"></vs-checkbox>
            <span class="legal-text">
              Acepto el
              <a target="_blank" href="https://verificamex.com/aviso-de-privacidad">Aviso de Privacidad Integral</a>
              del servicio.
            </span>
          </div>
          <span class="text-danger">{{ errors.first('privacy') }}</span>
        </div>

        <input type="submit" style="position: absolute; left: -9999px"/>

        <vs-button
          ref="loadableButton"
          id="button-with-loading"
          class="vs-con-loading__container register-button mt-5 w-full"
          :disabled="isSubmitted"
          @click="registerUserJWt"
          type="relief"
          color="primary">Crear mi cuenta</vs-button>

        <p class="login-link mt-4 text-center">
          ¿Ya tienes cuenta?
          <router-link to="/login">Inicia sesión</router-link>
        </p>
      </form>

    </div>

    <div v-if="isSuccess" class="min-h-re2">
      <div class="success-block">
        <div class="success-icon">
          <feather-icon icon="MailIcon" svgClasses="w-10 h-10" />
        </div>
        <h2 class="success-title">¡Revisa tu correo!</h2>
        <p class="success-text">
          Te enviamos un enlace de verificación a
          <span class="success-email">{{ email }}</span>.
        </p>
        <p class="success-text-secondary">
          ¿No lo encuentras? Revisa tu carpeta de Spam o reenvíalo desde aquí.
        </p>
        <vs-button
          ref="loadableButton"
          id="button-loading-resend"
          class="vs-con-loading__container success-button mt-5"
          :disabled="isSubmittedResendEmail"
          @click="resend_email"
          type="relief"
          color="primary">Reenviar correo</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { deviceFingerprint } from '@/_helpers';

export default {
  data () {
    return {
      tabIndex: 1,
      icon: 'EyeIcon',
      type: 'password',
      name: '',
      last_name: '',
      email: '',
      password: '',
      coupon: '',
      password_confirmation: '',
      isTermsConditionAccepted: false,
      isPrivacyNoticeAccepted: false,
      isSubmitted: false,
      isSubmittedResendEmail: false,
      utmSource: "",
      utmMedium: "",
      utmCampaign: "",
      gclid: "",
      fbclid: "",
      honeypotChecked: false
    }
  },
  computed: {
    isRegisterJwt() {
      return this.tabIndex === 1;
    },
    isSuccess() {
      return this.tabIndex === 2;
    }
  },
  methods: {
    resend_email() {
      this.isSubmittedResendEmail = true;
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: "#button-loading-resend",
        scale: 0.45
      });
      this.$store.dispatch("account/resend_verification_email", {email: this.email})
      .then(
        () => {
          this.$vs.loading.close("#button-loading-resend > .con-vs-loading");
          this.isSubmittedResendEmail = false;
        },
        () => {
          this.$vs.loading.close("#button-loading-resend > .con-vs-loading");
          this.isSubmittedResendEmail = false;
        }
      )
    },
    toggleTab(index) {
      this.tabIndex = index;
    },
    setPhone(email) {
      this.email = email;
    },
    showPassword() {
      if(this.type === 'password') {
        this.type = 'text'
        this.icon = 'EyeOffIcon'
      } else {
        this.type = 'password'
        this.icon = 'EyeIcon'
      }
    },
    registerUserJWt (e) {
      if (e) {
        e.preventDefault();
      }
      this.$store.dispatch('alert/clear', {}, { root: true });
      this.isSubmitted = true;
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          // Proceed with form submission
          this.$vs.loading({
            background: 'primary',
            color: '#fff',
            container: "#button-with-loading",
            scale: 0.45
          });
          const user = {
            name: this.name,
            email: this.email,
            last_name: this.last_name,
            password: this.password,
            password_confirmation: this.password_confirmation,
            utm_source: this.utmSource,
            utm_campaign: this.utmCampaign,
            utm_medium: this.utmMedium,
            gclid: this.gclid,
            fbclid: this.fbclid,
            coupon: this.coupon,
            isBot: this.honeypotChecked
          }
          this.$store.dispatch('account/register', user)
            .then(() => {
              this.isSubmitted = false;
              this.$vs.loading.close("#button-with-loading > .con-vs-loading");
              this.toggleTab(2);
            })
            .catch(error => {
              console.log('Error al registrar:', error);
              this.isSubmitted = false;
              this.$vs.loading.close("#button-with-loading > .con-vs-loading");
            })
        } else {
          this.$store.dispatch('alert/error', 'Ingrese los datos solicitados', { root: true });
          this.isSubmitted = false;
        }
      });
    }
  },
  mounted() {
    // Se calcula mientras el usuario llena el formulario; se manda al registrarse.
    deviceFingerprint.preload()
    if (this.$route.query.utm_source) {
      this.utmSource = this.$route.query.utm_source
      Cookies.set('utm_source', this.utmSource)
    }
    if (this.$route.query.utm_medium) {
      this.utmMedium = this.$route.query.utm_medium
      Cookies.set('utm_medium', this.utmMedium)
    }
    if (this.$route.query.utm_campaign) {
      this.utmCampaign = this.$route.query.utm_campaign
      Cookies.set('utm_campaign', this.utmCampaign)
    }
    if (this.$route.query.gclid) {
      this.gclid = this.$route.query.gclid
      Cookies.set('gclid', this.gclid)
    }
    if (this.$route.query.fbclid) {
      this.fbclid = this.$route.query.fbclid
      Cookies.set('fbclid', this.fbclid)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/vuexy/_colorsVariables.scss';

.d-inline-b {
  display: inline-block !important;
}
.is-invalid {
  border-color: red !important;
}
.text-danger {
  color: $danger;
  font-size: 0.78rem;
  display: block;
  margin-top: 4px;
}

/* ────────────────────────────────────────────────────────────────
   Header
   ──────────────────────────────────────────────────────────────── */
.register-header {
  text-align: left;
}
.register-title {
  font-size: 1.85rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 8px;
  line-height: 1.2;
}
.register-subtitle {
  font-size: 0.95rem;
  color: rgba(0, 0, 0, 0.55);
  line-height: 1.5;
  margin: 0;
}
.badge-free {
  display: inline-block;
  background: rgba(115, 103, 240, 0.12);
  color: $primary;
  font-weight: 600;
  font-size: 0.78rem;
  padding: 2px 10px;
  border-radius: 999px;
  margin-right: 6px;
  letter-spacing: 0.2px;
}

/* ────────────────────────────────────────────────────────────────
   Form groups + labels
   ──────────────────────────────────────────────────────────────── */
.form-group { display: block; }
.form-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.78);
  margin-bottom: 6px;
  letter-spacing: 0.1px;
}

/* vs-input override consistente con Login. */
.input-large {
  ::v-deep .vs-input--input {
    height: 42px;
    padding-top: 8px !important;
    padding-bottom: 8px !important;
    font-size: 0.95rem;
    transition: border-color 0.18s ease, box-shadow 0.18s ease;

    &:focus {
      border-color: $primary !important;
      box-shadow: 0 0 0 3px rgba(115, 103, 240, 0.12);
    }
  }
  ::v-deep .vs-input--placeholder {
    font-size: 0.95rem;
    color: rgba(0, 0, 0, 0.38);
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
  }
}

/* ────────────────────────────────────────────────────────────────
   Password toggle
   ──────────────────────────────────────────────────────────────── */
.password-wrapper { position: relative; }
.password-toggle {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: rgba(0, 0, 0, 0.45);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: color 0.18s ease;
  z-index: 2;

  &:hover { color: $primary; }
  &:focus { outline: none; color: $primary; }
}

/* ────────────────────────────────────────────────────────────────
   Términos / Privacidad
   ──────────────────────────────────────────────────────────────── */
.legal-block {
  background: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  padding: 12px 14px;
}
.legal-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.legal-text {
  font-size: 0.82rem;
  line-height: 1.45;
  color: rgba(0, 0, 0, 0.7);
  margin-top: 1px;

  a {
    color: $primary;
    font-weight: 500;
    text-decoration: none;

    &:hover { text-decoration: underline; }
  }
}

/* ────────────────────────────────────────────────────────────────
   Botón principal y link de login
   ──────────────────────────────────────────────────────────────── */
.register-button {
  height: 40px !important;
  font-size: 0.92rem;
  font-weight: 600;
  letter-spacing: 0.2px;
  padding: 0 !important;
  transition: transform 0.15s ease, box-shadow 0.2s ease;

  ::v-deep .vs-button-text {
    padding: 0 18px !important;
    line-height: 1;
  }

  &:hover:not(.disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(115, 103, 240, 0.25);
  }
}
.login-link {
  font-size: 0.92rem;
  color: rgba(0, 0, 0, 0.55);

  a {
    color: $primary;
    font-weight: 600;
    margin-left: 4px;
    text-decoration: none;

    &:hover { text-decoration: underline; }
  }
}

/* ────────────────────────────────────────────────────────────────
   Pantalla de éxito (post-registro)
   ──────────────────────────────────────────────────────────────── */
.success-block {
  text-align: center;
  padding: 32px 16px;
}
.success-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: rgba(115, 103, 240, 0.12);
  color: $primary;
  margin-bottom: 18px;
}
.success-title {
  font-size: 1.7rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 12px;
}
.success-text {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.7);
  line-height: 1.5;
  margin-bottom: 8px;
}
.success-email {
  color: $primary;
  font-weight: 600;
}
.success-text-secondary {
  font-size: 0.88rem;
  color: rgba(0, 0, 0, 0.5);
  line-height: 1.5;
  margin-bottom: 0;
}
.success-button {
  height: 40px !important;
  font-size: 0.92rem;
  font-weight: 600;
  padding: 0 !important;

  ::v-deep .vs-button-text {
    padding: 0 22px !important;
    line-height: 1;
  }
}

.honeypot-container {
  position: absolute;
  top: -9999px;
  left: -9999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0.001;
  pointer-events: none;
}
</style>
